import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, trackEvent, analyticsClient } from '../utils/analytics.js';

/**
 * Hook personnalisé pour suivre automatiquement les vues de pages et les changements d'onglets
 *
 * @param {Object} options - Options de configuration
 * @param {Object} options.currentUser - L'utilisateur connecté (facultatif)
 * @param {string} options.project - Le projet actif (facultatif)
 */
export default function useAnalytics(options = {}) {
  const location = useLocation();
  const { pathname } = location;
  const { currentUser, project, module, role } = options;

  // Suivi des changements de pages (sans le hash)
  useEffect(() => {
    let props = {};

    // Ajouter les infos d'utilisateur si disponibles
    if (currentUser) {
      props = {
        ...props,
        user: currentUser,
      };
    }

    if (role) {
      props = {
        ...props,
        role: role
      };
    }

    if (module) {
      props = {
        ...props,
        module: module
      };
    }

    if (project) {
      props = {
        ...props,
        client: analyticsClient(project)
      };
    }

    try {
      trackPageview({
        url: pathname,
      }, { props });
    } catch (error) {}
  }, [pathname, currentUser, project, role]);

  const track = (eventName, props) => {

    if (currentUser) {
      props = {
        ...props,
        user: currentUser,
      };
    }

    if (role) {
      props = {
        ...props,
        role: role
      };
    }

    if (project) {
      props = {
        ...props,
        client: project
      };
    }

    try {
      trackEvent(eventName, { props });
    } catch (error) {}
  };

  // Pas besoin de retourner quoi que ce soit, le hook s'occupe du tracking en arrière-plan
  return { track };
}